import { render, staticRenderFns } from "./PosNavigation.vue?vue&type=template&id=b4bf28de&scoped=true"
import script from "./PosNavigation.vue?vue&type=script&lang=js"
export * from "./PosNavigation.vue?vue&type=script&lang=js"
import style0 from "./PosNavigation.vue?vue&type=style&index=0&id=b4bf28de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4bf28de",
  null
  
)

export default component.exports